import Text from '@atoms/Text';
import React from 'react';
import texts from './en.json';
import Lottie from 'lottie-react';
import searching from '../../public/assets/searching-file.json';
import 'swiper/css';
import 'swiper/css/navigation';
import LazyImage from '@atoms/LazyImage';

export const ProductCreditAssessment = ({ productCreditAssessment }) => {
    const { listItems } =
        productCreditAssessment || {};

    const ProductRiskCard = (each, index) => {
        return (
            <div
                id={index}
                key={index}
                className="w-full md:w-auto md:h-56 bg-basicWhite/60 md:bg-basicWhite/50 p-4 md:p-9 md:m-5 rounded-[1.25rem] flex flex-col items-start flex-[1_0_0%]"
            >
                <div className="flex flex-col items-center md:items-start">
                    <Text
                        content={each.title}
                        htmlTag="h3"
                        className="text-primary-500 p4-semibold md:h5-semibold"
                    />
                </div>
                <ul className='mt-4 ml-4'>
                    {each?.bulletPoints.map((point, index) => (
                        <li className="list-disc" key={index}>
                            <Text
                                content={point}
                                className="text-gray-900 p5-regular md:p4-regular"
                            />
                        </li>
                    ))}
                </ul>
            </div>
        );
    };

    return (
        <div id="product-credit-assessment">
            {/* Tablet and Desktop view */}
            <div className='hidden px-6 xl:px-9 py-5 md:block xl:flex items-center'>
                <div className='hidden xl:basis-1/3 xl:flex flex-col items-center'>
                    <Text content={texts.creditAssessmentProcess.replaceAll(' ', '\n')} className="h3-regular whitespace-pre mb-15" htmlTag='h2' />
                    <div className='w-80 h-80'>
                        <Lottie
                            animationData={searching}
                            loop={true}
                            autoplay={true}
                        />
                    </div>
                </div>
                <div className='xl:basis-2/3 xl:h-[45rem] xl:w-full relative'>
                    <div className='relative w-full aspect-square xl:w-[45rem] xl:h-[45rem] bg-secondary-100/10 rounded-full flex justify-center items-center mx-auto p-16'>
                        <div className=' w-full h-full bg-secondary-200/10 rounded-full flex justify-center items-center p-16'>
                            <div className='w-full h-full bg-secondary-300/10 rounded-full'>
                                {listItems.map((each, index) => (
                                    <div key={index} className={`absolute ${index % 2 == 0 ? 'left-0' : 'right-0'} ${index < 2 ? 'bottom-1/2' : 'top-1/2'} w-1/2`}>
                                        {ProductRiskCard(each)}
                                    </div>
                                ))}
                            </div>
                        </div>
                        <LazyImage src='/images/shield.svg' className='absolute top-auto bottom-auto left-auto right-auto w-[154px] h-[154px]' />
                    </div>
                    <Text content={texts.creditAssessmentProcess} className="absolute xl:hidden h3-regular top-10 left-0 right-0 text-center mx-auto" htmlTag='h2' />
                </div>
            </div>
            {/* Mobile view */}
            <div className='relative md:hidden flex flex-col items-center h-[750px]'>
                <div className='absolute z-10 top-0 left-4 w-[750px] overflow-clip aspect-square bg-secondary-100/10 rounded-full flex justify-center items-center p-17'>
                    <div className='w-full aspect-square bg-secondary-200/10 rounded-full flex justify-center items-center p-17'>
                        <div className='w-full aspect-square bg-secondary-300/10 rounded-full '>

                        </div>
                    </div>
                </div>
                <div className='px-4 absolute flex flex-col justify-center h-full w-screen z-50'>
                    <div className='flex justify-between items-center gap-x-4'>
                        <Text content={texts.creditAssessmentProcess} className="text-basicBlack p3-medium" htmlTag='h2' />
                        <LazyImage src='/images/shield.svg' className='w-24 h-24 relative' />
                    </div>
                    <div className='mt-7 z-50 w-full flex flex-col gap-y-3'>
                        {listItems.map((each, index) => (
                            ProductRiskCard(each, index)
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
};
